import type { AccountClass, AccountType } from '../types';

export interface BasAccount {
  number: number;
  name: string;
  /** SRU code for INK2/INK3/NE as published in the BAS SRU mapping. */
  sruCode: string;
  type: AccountType;
}

export interface BasClassInfo {
  class: AccountClass;
  name: string;
  min: number;
  max: number;
  type: AccountType;
}

export const BAS_CLASSES: readonly BasClassInfo[] = [
  { class: 1, name: 'Tillgångar', min: 1000, max: 1999, type: 'asset' },
  { class: 2, name: 'Eget kapital och skulder', min: 2000, max: 2999, type: 'liability' },
  { class: 3, name: 'Rörelsens inkomster/intäkter', min: 3000, max: 3999, type: 'revenue' },
  { class: 4, name: 'Utgifter/kostnader för varor, material och vissa köpta tjänster', min: 4000, max: 4999, type: 'expense' },
  { class: 5, name: 'Övriga externa rörelseutgifter/kostnader', min: 5000, max: 5999, type: 'expense' },
  { class: 6, name: 'Övriga externa rörelseutgifter/kostnader', min: 6000, max: 6999, type: 'expense' },
  { class: 7, name: 'Utgifter/kostnader för personal, avskrivningar m.m.', min: 7000, max: 7999, type: 'expense' },
  { class: 8, name: 'Finansiella och andra inkomster/intäkter och utgifter/kostnader', min: 8000, max: 8999, type: 'expense' },
];
